import {USER_PROFILE_ALLOCATIONS} from '@/constants/engine';
import {Reference} from '@/model/types';
import {PluginValue} from '@/model/types/plugin';
import {
  createAllocationListOptions,
  registerAllocationPluginFiltersDependencies,
} from '../plugins/predetermined-allocations/processor/create-allocation-list-options';
import {DependencyRegistrer, ModelFactory} from '../types';

export const registerPluginFilters = (options: PluginValue, context: {dependencyRegistrer?: DependencyRegistrer}) => {
  switch (options.$plugin) {
    case USER_PROFILE_ALLOCATIONS:
      return registerAllocationPluginFiltersDependencies(options, context);
  }
};

export const createFactoryFromPlugin = (
  options: PluginValue,
  context: {dependencyRegistrer?: DependencyRegistrer},
): ModelFactory<Reference[]> => {
  switch (options.$plugin) {
    case USER_PROFILE_ALLOCATIONS:
      return createAllocationListOptions(options, context);
  }

  throw new Error(`Unknown plugin: ${options.$plugin}`);
};
